import { PlayCircle } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { guidedDemosWeb } from '../web-manifest.js';

// Routes are lazy-loaded directly in App.tsx (similar to docs), so we don't
// need to register page components here. Only icons and manifest metadata.
export default createWebRegistrationFromManifest(
  guidedDemosWeb,
  {},
  { icons: { PlayCircle } },
);
